<template>
	<div>
		<div class="station_right">
			<div class="station_right_in">
				<h2 class="station_right_h2">联系人信息
					<span class="fr content_font lastAddPer" v-show="yesMsg">您最多还可以添加<span v-text="numLength"></span>位联系人信息</span>
				</h2>
				<!--循环中间内容区域-->
				<div v-for='item in list'>
					<div class="contact_card msg_item_top" v-show="item.isbeforeShow">
						<ul>
							<li class="dev_list">
								<span class="contact_card_label">姓名：</span>
								<span class="contact_card_cont" v-text="item.name"></span>
							</li>
							<li class="dev_list">
								<span class="contact_card_label">电话：</span>
								<span class="contact_card_cont" v-text="item.phone"></span>
							</li>
							<li class="dev_list">
								<span class="contact_card_label">邮箱：</span>
								<span class="contact_card_cont" v-text="item.email"></span>
							</li>
						</ul>
						<div class="contact_card_btn">
							<a class="mRfifteen" href="javascript:;" @click="reviseNews(item)">修改</a>
							<a href="javascript:;" @click="deleteNews(item)">删除</a>
						</div>
					</div>

					<!--<div class="contact_edit" v-show="showStatafter">
							<div class="contact_card_btn">
								<a href="javascript:;" @click="emptyCont(item)">清空信息</a>
							</div>
							<div class="password_item clearfix">
								<label class="password_item_l">姓名：</label>
								<div class="info_item password_item_r mb20">
									<input type="text" placeholder="请输入您的姓名" v-model="item.name">
								</div>
							</div>
							<div class="password_item clearfix">
								<label class="password_item_l" >电话：</label>
								<div class="info_item password_item_r mb20">
									<input type="text" placeholder="请输入您的联系电话，用于接收重要通知" v-model="item.phone">
								</div>
							</div>
							<div class="password_item clearfix">
								<label class="password_item_l">邮箱：</label>
								<div class="info_item password_item_r mb20">
									<input type="text" placeholder="请输入您的企业邮箱，用户接收通知" v-model="item.email">
								</div>
							</div>
							<div class="password_item clearfix">
								<label class="password_item_l">&nbsp;</label>
								<div class="info_item password_item_r">
									<a href="javascript:;" class="blue_btn" @click="holdData(item)">&nbsp;保&nbsp;&nbsp;存&nbsp;</a>
								</div>
							</div>
						</div>-->
						
					<!--编辑修改联系人的组件，放在循环里面，每次都要循环取到当前的那个-->	
					<show-area @init = 'init'   @getSave="toSave" :item='item' :showStatafter='item.isShow' :isAdd='edit'></show-area>
					
					<Modal v-model="item.model1" @on-ok="ok(item)" @on-cancel="cancel(item)" title="信息" >
						<p>请确认是否删除联系人信息？</p>
					</Modal>
				</div>
				
				<!--添加联系人的组件-->
				<show-area @init = 'init' @getInit="toshow" :item='itemSave' :showStatafter='addShowAter' :isAdd='add'></show-area>
				
				<div class="contact_add_btn msg_item_top" v-show="addUser" @click="addUserNews">
					<img src="../../assets/images/contact_add.png" alt="" class="addImg"/>
					<p>添加联系人</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import ShowArea from '@/components/public/ShowArea'
	export default {
		name: "userNews",
		data() {
			return {
				addUser: false, //新增及添加联系人弹窗状态，默认隐藏
				showStatbefore: true,
				showStatafter: false, //填写信息的状态，默认是隐藏的状态，当点击触发的时候  改成true
				addShowAter: false,//新增联系人是否显示
				isSave:true,//
				name: "",
				phone: "",
				email: "",
				numLength: "3",
				username: "",
				list: {},
				itemSave: {
					contactId: '', // 联系人ID
					name: '', //姓名
					phone: '', //电话
					email: ''
				},
				userdevId: sessionStorage.getItem('devId'),
				add:true,
				edit:false,   //编辑状态 
				msgcont:'',
				yesMsg:true
			}
		},
		components: {
			ShowArea     // 声明子组件，上面引用了。
		},
		methods: {
			//修改联系人信息
			reviseNews(item) {	
				if(this.isSave){
					this.isSave = false;
					if(item.isShow){
						item.isShow = false;	
					}else{
						var centerList = this.list;
						for(var i = 0,len = centerList.length;i < len; i++){
							centerList[i].isShow = false;
							centerList[i].isbeforeShow = true;
						}
						item.isShow = true
					}
					if(item.isbeforeShow){
						item.isbeforeShow = false
					}else{
						item.isbeforeShow = true
					}
					this.addShowAter = false;
					if(this.numLength <= 0 ){
						this.addUser = false;
					}else{
						this.addUser = true;
					}					
				}else{
					this.$Message.error('您还有未保存的联系人！');
				}				
			},
			//删除联系人信息
			deleteNews(item) {
				if(this.isSave){
					item.model1 = true;
				}else{
					this.$Message.error('您还有未保存的联系人！');
				}
			},
			//模态框点击ok 的时候
			ok(item) {
				let deletParams = {
					devId: this.userdevId, //开发者ID
					contactId: item.contactId
				}
				this.http.post('/ystOpenPlatformBff/deleteContact', deletParams, res => {
					if(res.success) {
						this.$Message.success('联系人删除成功！');
						this.init();
					}
				})
			},
			//模态框点击取消的时候
			cancel(item) {
				this.modal1 = false;
			},
			//初始化的时候，后面会直接调。
			init() {
				const that = this;
				let params = {
					"devId": this.userdevId
				}; //查询的时候必须要传开发者ID
				this.http.post('/ystOpenPlatformBff/userContact', params, res => {
					
					if(res.success) {						
						if(res.data.length == 1) { //上面提示信息  numLength最多还能添加几个联系人的校验信息			
							that.numLength = 2;
							that.addUser = true;
						} else if(res.data.length == 2) {
							that.numLength = 1;
							that.addUser = true;
						} else if(res.data.length == 3) {
							that.numLength = 0;
							that.addUser = false;
						}else if(res.data.length == 0){
							that.numLength = 3;
							that.addUser = true;
						}
						for(var i = 0,len = res.data.length;i < len; i++){
							res.data[i].isbeforeShow = true;
							res.data[i].isShow = false;
							res.data[i].model1 = false;
						}					
						//循环中间的部分区域
						this.list = res.data;

						
					}else {
						//this.yesMsg = false;
						that.numLength = 3;
						this.addUser = true;//查询失败可以继续让其添加联系人
						this.list = '';
						
					}
				})
			},
			toshow(list, numLength, addUser, show, isSave) {
				if(list){
					this.list = list;
				}
				if(numLength != 100){
					this.numLength = numLength;
				}
				if(addUser != 100){
					this.addUser = addUser;
				}
				this.addShowAter = show;
				this.isSave = isSave;
				this.itemSave= {
					contactId: '', // 联系人ID
					name: '', //姓名
					phone: '', //电话
					email: ''
				};
			},
			toSave(isSave){
				this.isSave = isSave;
			},
			//添加联系人
			addUserNews() {
				if(this.isSave){
					this.isSave = false;
					if(!this.showStatafter) {   	// true  添加联系人弹窗显示的时候
						if(this.numLength == 1){
							this.addUser = false;    //下面的添加联系人的提示标志不会显示
						}else{
							this.addUser = true;    //下面的添加联系人的提示标志会显示
						}
						
						this.addShowAter = true;
						var centerList = this.itemSave;
						for(var i = 0,len = centerList.length;i < len; i++){
							centerList[i].isShow = false;
							centerList[i].isbeforeShow = true;
							
						}											
					 }				
				}else{
					this.$Message.error('您还有未保存的联系人！');
				}		
			}
		},
		//开发者联系人初始化的时候调接口查询联系人信息
		mounted() { //相当于document.ready后执行的方法 ，DOM元素全部都加载完成之后执行的方法 
			this.init()
		}
	}
</script>
<style lang="scss">
	.contact_add_btn {
		text-align: center;
		font-size: 14px;
		color: $subcolor;
		margin-top: 20px;
	}
	
	.subtit {
		color: $subcolor;
		font-size: 12px;
		margin-left: 5px;
	}
	
	.contact_edit {
		border: 3px solid $link;
		padding: 30px 20px;
		position: relative;
		margin-bottom: 20px;
	}
	
	.contact_edit .password_item {
		width:560px;
	}
	
	.contact_edit .blue_btn_big {
		margin-left: 0;
	}
	
	.dev_info_card {
		line-height: 36px;
		position: relative;
		margin-bottom: 0;
	}
	
	.copy_btn {
		color: $link;
		margin-left: 15px;
	}
	.addImg{width: 45px;height: 50px;}
	.lastAddPer{margin-top: 14px;}
</style>


// WEBPACK FOOTER //
// src/components/_developCenter/UserNews.vue